import styled from 'styled-components';
import Wrapper from 'gatsby-theme-core/src/components/form-elements/title/wrapper';

export default styled(Wrapper)`
  &:first-of-type {
    font-size: 1.25rem;
    margin: 0 0 2rem 0;
  }
  &:not(:first-of-type) {
    margin-top: 2rem;
  }
`;
